import { PAYMENT_METHOD_HASH_TYPE_OXXO } from '../../constants';

export const oxxoPaymentMethodHashPayloadFactory = (
  paymentMethodId: string,
  name: string,
  email: string,
): object => ({
  type: PAYMENT_METHOD_HASH_TYPE_OXXO,
  oxxo: {
    token: paymentMethodId,
  },
  billing_details: {
    name,
    email,
  },
});
